import Header from "../components/Header";
import Footer from "./Footer";
import backgroundImg from "../images/backgroundImg.png";
import React from "react";
import RequestFormModal from "../components/RequestFormModal";
import ReadMore from "@/components/ReadMore";

const Home: React.FC = () => {
  const handleOpenModal = () => {
    const modal = document.getElementById(
      "request",
    ) as HTMLDialogElement | null;
    modal?.showModal();
  };
  return (
    <div className="flex flex-col items-start min-h-screen">
      <div className="absolute lg:relative z-30 h-[10%] w-[100%] max-w-[100%]">
        <Header />
      </div>
      <div
        className="hidden lg:flex min-w-[100%] lg:h-[35vh] h-[17vw] xl:max-h-[35vh] bg-valpeacock"
        style={{
          backgroundImage: `url(${backgroundImg})`,
          backgroundSize: "33%",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "85% 63%",
        }}>
        <div className="flex flex-col justify-center  text-white text-[40px] w-[90%] lg:w-[80%] mx-auto">
          <div className="font-bold mb-4">EARTH-HCM </div>
          <div className="flex flex-col text-[28px] text-white">
            Bridges the gap in awareness and education about HCM
            <button className="flex btn w-[10vw] mt-8 btn-circle font-bold text-[18px] bg-white text-valmidnight">
              <a href="/tool">Go to Tool</a>
            </button>
          </div>
        </div>
      </div>
      <div className="lg:hidden min-w-[100%] h-[70vh] md:h-[85vh] relative">
        <div className="absolute inset-0 z-0 bg-gradient-to-b from-valpeacock to-white" />
        <div
          className="absolute inset-0 z-10"
          style={{
            backgroundImage: `url(${backgroundImg})`,
            backgroundSize: window.innerWidth > 768 ? "75%" : "100%",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundPositionY: "70%",
          }}
        />
        <div className="relative z-20 text-white h-full pt-[120px] w-[60%] mx-auto">
          <div className="font-bold text-center mb-4 text-[28px]">
            EARTH-HCM{" "}
          </div>
          <div className="h-[80%] md:h-[85%] justify-between flex flex-col text-center text-[16px] text-white">
            Bridges the gap in awareness and education about HCM
            <button className="mx-auto flex btn w-[120px] btn-circle font-bold text-[18px] bg-[#1C8794] text-white">
              <a href="/tool">Go to Tool</a>
            </button>
          </div>
        </div>
      </div>
      <div className="w-[90%] lg:w-[80%] mx-auto flex flex-col justify-center">
        <div className="my-3 font-bold text-[24px] md:text-[28px] lg:text-[30px] text-valpeacock">
          About Hypertrophic Cardiomyopathy
        </div>
        <p className="mb-8 hidden lg:block  text-valmidnight text-[16px] lg:text-[20px] text-justify">
          Hypertrophic cardiomyopathy (HCM) is a disease in which the heart
          muscle (myocardium) becomes abnormally thick (hypertrophied). The
          thickening of cardiac muscle leads to the inside of the left ventricle
          becoming smaller and stiffer, and thus the ventricle becomes less able
          to relax and fill with blood. This ultimately limits the heart’s
          pumping function, resulting in reduced exercise capacity and symptoms
          including chest pain, dizziness, shortness of breath, or fainting
          during physical activity. HCM is the most common monogenic inherited
          cardiovascular disorder, with approximately 260,000 patients diagnosed
          <sup>1</sup>, however, there are an estimated 400,000-800,000
          additional patients who remain undiagnosed in the U.S.
          <sup>2,3,4</sup> Forty percent of patients with HCM have obstructive HCM (oHCM), where
          the thickening of the cardiac muscle leads to left ventricular outflow
          tract (LVOT) obstruction, while sixty percent have non-obstructive HCM
          (nHCM), where blood flow isn’t impacted, but the heart muscle is still
          thickened.<sup>1</sup> People with HCM are at high risk of also
          developing cardiovascular complications including atrial fibrillation,
          stroke and mitral valve disease.<sup>5</sup> People with HCM are at
          risk for potentially fatal ventricular arrhythmias and it is one of
          the leading causes of sudden cardiac death in younger people or
          athletes.
          <sup>4</sup> A subset of patients with HCM are at high risk of
          progressive disease leading to dilated cardiomyopathy and heart
          failure necessitating cardiac transplantation. Although the clinical
          profile, and management of patients with HCM have been well described
          in the existing literature, there is limited real-world data
          representing a national population of patients with HCM and their
          clinical-outcomes, healthcare-resource use and healthcare costs in
          patients with HCM.
        </p>
        <ReadMore
          collapsedHeight={200}
          html={` Hypertrophic cardiomyopathy (HCM) is a disease in which the heart
          muscle (myocardium) becomes abnormally thick (hypertrophied). The
          thickening of cardiac muscle leads to the inside of the left ventricle
          becoming smaller and stiffer, and thus the ventricle becomes less able
          to relax and fill with blood. This ultimately limits the heart’s
          pumping function, resulting in reduced exercise capacity and symptoms
          including chest pain, dizziness, shortness of breath, or fainting
          during physical activity. HCM is the most common monogenic inherited
          cardiovascular disorder, with approximately 260,000 patients diagnosed<sup>1</sup>, however, there are an estimated 400,000-800,000
          additional patients who remain undiagnosed in the U.S.<sup>2,3,4</sup>
          Forty percent of patients with HCM have obstructive HCM (oHCM), where
          the thickening of the cardiac muscle leads to left ventricular outflow
          tract (LVOT) obstruction, while sixty percent have non-obstructive HCM
          (nHCM), where blood flow isn’t impacted, but the heart muscle is still
          thickened.<sup>1</sup> People with HCM are at high risk of also
          developing cardiovascular complications including atrial fibrillation,
          stroke and mitral valve disease.<sup>5</sup> People with HCM are at
          risk for potentially fatal ventricular arrhythmias and it is one of
          the leading causes of sudden cardiac death in younger people or
          athletes.<sup>4</sup> A subset of patients with HCM are at high risk of
          progressive disease leading to dilated cardiomyopathy and heart
          failure necessitating cardiac transplantation. Although the clinical
          profile, and management of patients with HCM have been well described
          in the existing literature, there is limited real-world data
          representing a national population of patients with HCM and their
          clinical-outcomes, healthcare-resource use and healthcare costs in
          patients with HCM.`}
        />

        <h2 className="font-bold text-[24px] md:text-[28px] lg:text-[30px] text-valpeacock my-3">
          EARTH-HCM
        </h2>
        <p className="hidden lg:block  text-valmidnight text-[16px] lg:text-[20px] text-justify">
          EARTH-HCM (<b>E</b>pidemiology, <b>A</b>wareness, <b>R</b>eal-world
          <b>T</b>reatment and <b>H</b>ealth Outcomes in <b>HCM</b>), is an
          online, open access, public health education tool developed by
          Cytokinetics, in collaboration with leading academic institutions,
          that uses real-world deidentified claims data to visualize population
          differences in patient characteristics, treatments, clinical outcomes,
          healthcare resource utilization and costs in hypertrophic
          cardiomyopathy (HCM) in the U.S. EARTH-HCM is an innovative,
          user-friendly tool designed to bridge the gap in awareness and
          education about HCM by providing insights into the treatment landscape
          and disparities in care. The tool aims to serve a variety of
          stakeholders including patients and caregivers, clinicians,
          pharmacists, researchers, policy decision-makers, payors and patient
          advocacy groups. This tool gives stakeholders detailed insights to
          guide resource allocation, optimize care strategies, and better
          support patients across the spectrum of HCM. EARTH-HCM will be updated
          regularly with publicly available data and will be expanded to include
          data from global geographies.
        </p>
        <ReadMore
          collapsedHeight={200}
          html={`EARTH-HCM (<b>E</b>pidemiology, <b>A</b>wareness, <b>R</b>eal-world
          <b>T</b>reatment and <b>H</b>ealth Outcomes in <b>HCM</b>), is an
          online, open access, public health education tool developed by
          Cytokinetics, in collaboration with leading academic institutions,
          that uses real-world deidentified claims data to visualize population
          differences in patient characteristics, treatments, clinical outcomes,
          healthcare resource utilization and costs in hypertrophic
          cardiomyopathy (HCM) in the U.S. EARTH-HCM is an innovative,
          user-friendly tool designed to bridge the gap in awareness and
          education about HCM by providing insights into the treatment landscape
          and disparities in care. The tool aims to serve a variety of
          stakeholders including patients and caregivers, clinicians,
          pharmacists, researchers, policy decision-makers, payors and patient
          advocacy groups. This tool gives stakeholders detailed insights to
          guide resource allocation, optimize care strategies, and better
          support patients across the spectrum of HCM. EARTH-HCM will be updated
          regularly with publicly available data and will be expanded to include
          data from global geographies.`}
        />

        <div className="flex justify-evenly mx-auto my-10">
          <button
            className="btn lg:px-10 px-5 bg-valpeacock text-white rounded-full hover:text-valmidnight hover:border-color-valmidnight hover:bg-white"
            onClick={() => handleOpenModal()}>
            Research Request
          </button>
          <RequestFormModal />
        </div>
        <div className="text-[12px] lg:text-[13px] text-justify mb-6">
          <ul>
            <li>
              1. Butzner M, Maron M, Sarocco P, et al. Clinical Diagnosis of
              Hypertrophic Cardiomyopathy Over Time in the United States (A
              Population-Based Claims Analysis). Am J Cardiol. 2021;159:107-112.
              doi:10.1016/j.amjcard.2021.08.024
            </li>
            <li>
              2. CVrg: Heart Failure 2020-2029, p 44; Maron et al. 2013 DOI:
              10.1016/S0140-6736(12)60397-3; Maron et al 2018
              10.1056/NEJMra1710575
            </li>
            <li>
              3. Maron MS, Hellawell JL, Lucove JC, Farzaneh-Far R, Olivotto I.
              Occurrence of Clinically Diagnosed Hypertrophic Cardiomyopathy in
              the United States. Am J Cardiol. 2016; 15;117(10):1651-1654.
            </li>
            <li>
              4. Gersh, B.J., Maron, B.J., Bonow, R.O., Dearani, J.A., Fifer,
              M.A., Link, M.S., et al. 2011 ACCF/AHA guidelines for the
              diagnosis and treatment of hypertrophic cardiomyopathy. A report
              of the American College of Cardiology Foundation/American Heart
              Association Task Force on practice guidelines. Journal of the
              American College of Cardiology and Circulation, 58, e212-260.
            </li>
            <li>
              5. Ommen et al. Circulation. 2024;149:e1239-e1311. Stroumpoulis et
              al. World J Cardiol. 2010;2:289-298. Fifer et al. Circulation.
              2008;117:429-439.
            </li>
          </ul>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Home;
